module.exports = __webpack_public_path__ + "img/payless.307bafb6.gif";